import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Dialog } from '@mui/material';
import ModalCard, { ModalRow, ModalTitle } from '../../../components/modal/ModalCard';
import Progress from '../../../components/progress/Progress';
import eslTemplateService from '../../../services/esl/EslTemplateService';
import { useNavigate } from 'react-router-dom';

interface IDeleteEslTemplateModalProps {
  isModalOpen: boolean;
  onCloseModal: () => void;
  templateId: string;
}

const DeleteEslTemplateModal = ({ isModalOpen, onCloseModal, templateId }: IDeleteEslTemplateModalProps) => {
  const { t } = useTranslation(['eslTemplate', 'common']);
  const navigate = useNavigate();
  const [isLoading, setIsFormSending] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onDeleteEslTemplate = async () => {
    setIsFormSending(true);
    eslTemplateService.DeleteEslTemplate(templateId)
      .then(() => {
        onCloseModal();
        navigate(0);
      })
      .catch(() => setErrorMessage(t('eslTemplate:deleteModal.deleteError')))
      .finally(() => setIsFormSending(false));
  }

  return (
    <Dialog open={isModalOpen} onClose={onCloseModal}>
      <ModalCard sx={{ borderRadius: 4, height: '100%', overflow: 'auto' }} title={t("eslTemplate:deleteModal.deleteModalTitle")} closeCallback={onCloseModal}>
        <ModalCard.Main isDivider={false}>
          {errorMessage && (
            <Alert
              severity="error"
              sx={{ marginBottom: "1em" }}
            >
              {errorMessage}
            </Alert>
          )}
          <ModalRow>{t("eslTemplate:deleteModal.deleteModalContent")}</ModalRow>
        </ModalCard.Main>

        <ModalCard.Action>
          <Progress isLoading={isLoading}>
            <Button color="primary" onClick={onCloseModal}>
              <ModalTitle>{t('eslTemplate:deleteModal.cancelButton')}</ModalTitle>
            </Button>
            <Button variant="contained" color="error" onClick={onDeleteEslTemplate}>
              <ModalTitle>{t('eslTemplate:deleteModal.deleteButton')}</ModalTitle>
            </Button>
          </Progress>
        </ModalCard.Action>

      </ModalCard>
    </Dialog>
  );
};

export default DeleteEslTemplateModal;
